import { observable } from "mobx";
import { IsNotEmpty } from "class-validator";
import { classToPlain, plainToClass } from "class-transformer";
import locale from "@bonliva-crm/locale";
import { omit } from "@bonliva-crm/common";
import {
  CustomerRefInput,
  SearchProfileFormInput as ISearchProfileFormInput,
  SearchProfileFragment,
  SearchProfileType
} from "@graphql";

export class SearchProfileFormInput implements ISearchProfileFormInput {
  static CreateFromFragment(data: SearchProfileFragment) {
    const item = plainToClass(SearchProfileFormInput, data, {
      excludePrefixes: ["__"]
    });
    return item;
  }

  getPlain(): ISearchProfileFormInput {
    const plain = classToPlain(this, { excludePrefixes: ["__"] });
    return omit(plain, "_id") as any;
  }

  @IsNotEmpty({ message: locale.Title })
  @observable
  name: string = "";

  @observable
  type: SearchProfileType;

  @observable
  customerRefs: CustomerRefInput[];

  @observable
  fields: string; // JSON stringify

  // @observable
  // deleted = false;
}
